import { IModalStore } from '../index'
import { IOpenModal } from '../../../actions/Modals/openModal'

const openModal = (store: IModalStore, action: IOpenModal): IModalStore => ({
  ...store,
  tooltips: [],
  modals: [
    ...store.modals.filter(m => m.id !== action.id + action.uid),
    {
      element: action.element,
      id: action.id + action.uid,
    },
  ],
})

export default openModal
